import { AppError } from "@/core/common/http/errors/app.error";

export class TooManyRequestsError extends AppError {
  constructor(message: string, url: string) {
    super(
      message,
      429,
      "Too Many Requests",
      url,
      "El servicio está temporalmente saturado. Por favor, espera unos segundos e intenta de nuevo."
    );
  }
}
